<div class="container-fluid">
  <app-header titleText="Dealer Licensure" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <div class="col-sm-6">
          <div class="form-inline">
            <label for="dealer_ID" class="col-form-label" i18n>Dealer</label>
            <select name="dealer_ID" id="dealer_ID"
                    [(ngModel)]="parameters.dealer_ID" #dealer_ID="ngModel"
                    class="form-control select-bidit"
                    (change)="loadReport()">
              <option value="null" i18n>All</option>
              <option *ngFor="let dealer of dealers" [ngValue]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
            </select>
            <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
          </div>
        </div>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null">
    <h5 i18n>Please provide report criteria</h5>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <ng-template [ngIf]="dealer"><span i18n>Dealer:</span> {{dealer.dealer_BusinessName}}<br /></ng-template>
          <ng-template [ngIf]="!dealer"><span i18n>Dealer: All Dealers</span><br /></ng-template>
        </p>
      </div>
    </div>

    <div class="content">
      <div>
        <h2 i18n>Licensure</h2>
        <div>
          <table class="table compact table-bidit">
            <thead>
              <tr>
                <th i18n>Dealer</th>
                <th i18n>Current Licenses</th>
                <th i18n>Licenses Used</th>
                <th i18n>Active Field Techs</th>
                <th i18n>Active Sales Non-Bidit</th>
              </tr>
            </thead>
            <tbody *ngFor="let dealer of report">
              <tr>
                <td><strong>{{dealer.dealer_BusinessName}}</strong></td>
                <td>{{dealer.licensesPurchased}}</td>
                <td>{{dealer.licensesUsed}}</td>
                <td>{{dealer.activeFieldTechs}}</td>
                <td>{{dealer.activeSalesNoLicense}}</td>
              </tr>
              <tr>
                <td class="bg-light bidit-text-primary"><strong i18n>License History</strong><br /><span>Purchased Date</span></td>
                <td class="bg-light bidit-text-primary" i18n># Purchased</td>
                <td colspan="5" class="border-0"></td>
              </tr>
              <tr *ngFor="let licenseHistory of dealer.licenseHistory">
                <td>{{licenseHistory.licensesPurchasedDate | date: 'MM/dd/yyyy h:mm a'}}</td>
                <td>{{licenseHistory.numberofLicensesPurchased}}</td>
                <td colspan="5" class="border-0"></td>
              </tr>
              <tr *ngIf="dealer.licenseHistory.length == 0">
                <td colspan="2" i18n>No license history</td>
                <td colspan="5" class="border-0"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

